import { connect, ConnectedProps } from 'react-redux';
import { StateType } from '../../../state/state.types';
import { hasAggregation } from '../../search-utils/searchFiltersUtils';

const mapState = ({ aggregations, queryParams }: StateType) => ({
  shouldDisplayVille: hasAggregation(aggregations, 'ville'),
  shouldDisplayDomaine: hasAggregation(aggregations, 'domaine'),
  shouldDisplayPubli: hasAggregation(aggregations, 'publi'),
  shouldDisplaySolution: hasAggregation(aggregations, 'solution'),
  shouldDisplayPublisher: hasAggregation(aggregations, 'publisher'),
  shouldDisplayCommentaryAccess: hasAggregation(
    aggregations,
    'commentaryAccess',
  ),
  shouldDisplayPwCategory: hasAggregation(aggregations, 'pwCategory'),
  shouldDisplayPwLegislativeFolder: hasAggregation(
    aggregations,
    'pwLegislativeFolder',
  ),
  shouldDisplayJuridiction: hasAggregation(aggregations, 'juridiction'),
  shouldDisplayDate:
    (aggregations.dates && aggregations.dates.length) ||
    queryParams.type === 'arret' ||
    queryParams.type === 'commentary' ||
    queryParams.type === 'preparatory_work',
  shouldDisplayExclude: queryParams.type === 'arret',
  shouldDisplayParties: queryParams.type === 'arret',
  shouldDisplayInForceDate: queryParams.type === 'law',
  shouldDisplayTextCode:
    queryParams.type === 'law' && hasAggregation(aggregations, 'textCode'),
  shouldDisplayCollectiveAgreements:
    queryParams.type === 'law' &&
    hasAggregation(aggregations, 'collectiveAgreements'),
  shouldDisplayOtherLegislation:
    queryParams.type === 'law' &&
    hasAggregation(aggregations, 'otherLegislation'),
  search_type: queryParams.type,
});

export const Connect = connect(mapState);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
